import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f56c6dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-txt" }
const _hoisted_2 = { class: "avatar-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "avatar-text"
}
const _hoisted_5 = { class: "label-form" }
const _hoisted_6 = { class: "label-form" }
const _hoisted_7 = { class: "label-form" }
const _hoisted_8 = { class: "label-form" }
const _hoisted_9 = { class: "label-form" }
const _hoisted_10 = { class: "label-form" }
const _hoisted_11 = { class: "label-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_a_segmented = _resolveComponent("a-segmented")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_CameraOutlined = _resolveComponent("CameraOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input_password = _resolveComponent("a-input-password")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loader, {
      "is-loaded": !_ctx.loading
    }, null, 8, ["is-loaded"]),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          span: 24,
          class: "options-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_segmented, {
              value: _ctx.activeTab,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
              options: _ctx.tabList,
              onChange: _ctx.onTabChange
            }, null, 8, ["value", "options", "onChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.activeTab === _ctx.t('Meet.Profile') )
      ? (_openBlock(), _createBlock(_component_a_card, {
          key: 0,
          class: "profile-card"
        }, {
          title: _withCtx(() => [
            _createVNode(_component_a_row, {
              class: "title-row",
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: { span: 24},
                  sm: { span: 24},
                  md: {span: 12},
                  lg: { span: 12 },
                  xl: { span:12 },
                  xxl: { span:12 },
                  class: "title-text"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.t('Meet.ProfileDetails')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: { span: 24},
                  sm: { span: 24},
                  md: {span: 12},
                  lg: { span: 12 },
                  xl: { span:12 },
                  xxl: { span:12 },
                  class: "avatar-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_a_avatar, { size: 70 }, {
                        default: _withCtx(() => [
                          (_ctx.profileForm.photo)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.profileForm.photo,
                                alt: "avatar"
                              }, null, 8, _hoisted_3))
                            : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.state.firstName), 1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CameraOutlined, {
                        class: "camera-icon",
                        onClick: _ctx.triggerFileInput
                      }, null, 8, ["onClick"]),
                      _createElementVNode("input", {
                        type: "file",
                        ref: "fileInput",
                        class: "file-input",
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                      }, null, 544)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              ref: "profileRef",
              model: _ctx.profileForm,
              rules: _ctx.rules,
              layout: "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 12},
                      lg: { span: 12 },
                      xl: { span:12 },
                      xxl: { span:12 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { name: "firstName" }, {
                          label: _withCtx(() => [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('Meet.FisrtName')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.profileForm.firstName,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileForm.firstName) = $event)),
                              placeholder: _ctx.t('Meet.FisrtName'),
                              class: "input-form"
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 12},
                      lg: { span: 12 },
                      xl: { span:12 },
                      xxl: { span:12 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { name: "lastName" }, {
                          label: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('Meet.LastName')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.profileForm.lastName,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileForm.lastName) = $event)),
                              placeholder: _ctx.t('Meet.LastName'),
                              class: "input-form"
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 12},
                      lg: { span: 12 },
                      xl: { span:12 },
                      xxl: { span:12 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "email",
                          "has-feedback": "",
                          "validate-status": _ctx.validatingStatus,
                          help: _ctx.validatingHelp
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('Meet.Email')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.profileForm.email,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profileForm.email) = $event)),
                              placeholder: _ctx.t('Meet.Email'),
                              onBlur: _ctx.validateEmail
                            }, null, 8, ["value", "placeholder", "onBlur"])
                          ]),
                          _: 1
                        }, 8, ["validate-status", "help"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 12},
                      lg: { span: 12 },
                      xl: { span:12 },
                      xxl: { span:12 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "phone",
                          "has-feedback": ""
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('Meet.Phone')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.profileForm.phone,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.profileForm.phone) = $event)),
                              placeholder: _ctx.t('Meet.Phone')
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createVNode(_component_a_row, { class: "card-footer" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateUser(_ctx.profileForm.id)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('Meet.SaveChanges')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      danger: "",
                      onClick: _ctx.resetFormProf
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_ctx.activeTab === _ctx.t('Meet.Security'))
        ? (_openBlock(), _createBlock(_component_a_card, {
            key: 1,
            class: "profile-card"
          }, {
            title: _withCtx(() => [
              _createVNode(_component_a_row, {
                class: "title-row",
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 12,
                    class: "title-text"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_ctx.t('Meet.ChangePassword')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                ref: "securityRef",
                model: _ctx.securityForm,
                rules: _ctx.securityRules,
                layout: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: { span: 24},
                        sm: { span: 24},
                        md: {span: 24},
                        lg: { span: 24 },
                        xl: { span:24 },
                        xxl: { span:24 }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            "has-feedback": "",
                            name: "current"
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('Meet.CurrentPass')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_password, {
                                value: _ctx.securityForm.current,
                                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.securityForm.current) = $event)),
                                autocomplete: "off"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: { span: 24},
                        sm: { span: 24},
                        md: {span: 24},
                        lg: { span: 24 },
                        xl: { span:24 },
                        xxl: { span:24 }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            "has-feedback": "",
                            name: "pass"
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('Meet.Password')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_password, {
                                value: _ctx.securityForm.pass,
                                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.securityForm.pass) = $event)),
                                type: "password",
                                autocomplete: "off"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            "has-feedback": "",
                            name: "checkPass"
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('Meet.Confirmpassword')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_password, {
                                value: _ctx.securityForm.checkPass,
                                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.securityForm.checkPass) = $event)),
                                type: "password",
                                autocomplete: "off"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createVNode(_component_a_row, { class: "card-footer" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateUserPass()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Meet.UpdatePass')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        danger: "",
                        onClick: _ctx.resetFormPass
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Meet.Cancel')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
  ], 64))
}